export default angular.module( 'app-checkout', ['ngRoute','ngCookies']);



// WEBPACK FOOTER //
// ./src/js/App.js